import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { effect, inject, Injectable, PLATFORM_ID, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DarkModeService {
  readonly #document = inject(DOCUMENT);
  readonly #platformId = inject(PLATFORM_ID);

  readonly darkMode = signal(false);

  constructor() {
    const savedTheme = isPlatformBrowser(this.#platformId)
      ? localStorage.getItem('theme')
      : null;

    this.darkMode.set(savedTheme === 'dark');

    effect(() => {
      const html = this.#document.documentElement;

      if (this.darkMode()) {
        html.classList.add('dark');

        if (isPlatformBrowser(this.#platformId)) {
          localStorage.setItem('theme', 'dark');
        }
      } else {
        html.classList.remove('dark');

        if (isPlatformBrowser(this.#platformId)) {
          localStorage.setItem('theme', 'light');
        }
      }
    });
  }

  toggleDark(): void {
    this.darkMode.update((value) => !value);
  }
}